import { useConfigContext } from '@/lib/ConfigContext';
import { normalizeLanguageAliasCode, normalizeLanguageCode, normalizeLanguageMap, toLanguageAliasKey } from '@/lib/language';
export const useConfig = () => {
    const context = useConfigContext();
    const languageAliases = (context.config?.common?.languages ?? []).reduce((acc, lang) => {
        const iso2 = normalizeLanguageCode(lang.isoCode);
        if (iso2) {
            acc[toLanguageAliasKey(lang.isoCode)] = iso2;
        }
        const legacyAlias = toLanguageAliasKey(lang.isoCode3);
        if (legacyAlias && iso2) {
            acc[legacyAlias] = iso2;
        }
        return acc;
    }, {});
    return {
        config: context.config,
        isLoading: context.isLoading,
        error: context.error,
        isInitialized: context.isInitialized,
        loadConfig: context.loadConfig,
        resetConfig: context.resetConfig,
        agencyAlias: context.config?.agencyAlias || null,
        version: context.config?.version || null,
        common: context.config?.common || null,
        languages: context.config?.common?.languages || [],
        currencyFormat: context.config?.common?.currencyFormat || null,
        dateDescription: context.config?.common?.dateDescription || null,
        phoneFormats: context.config?.common?.phoneFormats || [],
        application: context.config?.application || null,
        appInfo: context.config?.application?.info || null,
        icons: context.config?.application?.icons || null,
        links: context.config?.application?.links || null,
        footer: context.config?.application?.footer || null,
        headerLinks: context.config?.application?.header?.links || [],
        isReady: context.isInitialized && !context.isLoading && !context.error && context.config !== null,
        hasError: context.error !== null,
        getLanguageByCode: (code) => {
            const normalizedCode = normalizeLanguageCode(code);
            if (!normalizedCode) {
                return null;
            }
            return context.config?.common?.languages?.find(lang => normalizeLanguageCode(lang.isoCode) === normalizedCode) || null;
        },
        getLinkByPath: (path) => {
            return context.config?.application?.header?.links?.find(link => link.path === path) || null;
        },
        getMultiLangString: (multiLangStr, langCode = 'en') => {
            if (typeof multiLangStr === 'string') {
                return multiLangStr;
            }
            const normalizedMap = normalizeLanguageMap(multiLangStr, languageAliases);
            const normalizedLang = normalizeLanguageCode(langCode)
                || languageAliases[toLanguageAliasKey(langCode)]
                || normalizeLanguageAliasCode(langCode)
                || 'en';
            return normalizedMap[normalizedLang]
                || normalizedMap.en
                || normalizedMap.it
                || Object.values(normalizedMap)[0]
                || '';
        },
    };
};
export default useConfig;
